import React, { useState } from "react";
import { InputLabel, Select, MenuItem, FormControl, SelectChangeEvent } from "@mui/material";
import { builder } from "Classes/global";

type Wall = "north" | "south" | "east" | "west" | "placeholder";

const AddAccessPointComponent = (): JSX.Element => {
    const [wall, setWall] = useState<Wall>("placeholder");

    const handleSelect = (e: SelectChangeEvent) => {
        const value = e.target.value as Wall;

        if (value === "placeholder") return;
        builder.addAccessPoint(value);
    };

    return (
        <div className="roomSizeContainer">
            <h2 className="desktop-title">Access Points</h2>

            <FormControl fullWidth>
                <InputLabel id="room-select-label">Select Wall</InputLabel>
                <Select
                    labelId="room-select-label"
                    id="room-select"
                    value={wall}
                    label="Select Wall"
                    onChange={handleSelect}
                >
                    <MenuItem value="placeholder">Select Wall</MenuItem>
                    <MenuItem value="north">North</MenuItem>
                    <MenuItem value="east">East</MenuItem>
                    <MenuItem value="south">South</MenuItem>
                    <MenuItem value="west">West</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
};

export default AddAccessPointComponent;
